import { CSSProperties } from 'react';
import { Interpolation, Theme } from '@emotion/react';
import { theme } from '@frontend/theme';

export const linkStyles: Interpolation<Theme> = {
  fontWeight: theme.font.weight.bold,
  textDecoration: 'none',
  color: theme.colors.primary50,
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
  '&:active, &:visited': { color: theme.colors.primary50 },
  '&:focus-visible': { outline: 'none' },
};

export const iframeStyles = (show: boolean): CSSProperties => ({
  display: show ? 'block' : 'none',
  width: '100%',
  height: '100%',
  zoom: '0.4',
  border: 'none',
  overflow: 'hidden',
  pointerEvents: 'none',
});

export const imgContentPlaceholderStyles: Interpolation<Theme> = {
  height: '100%',
};

export const overlayContainerStyles: Interpolation<Theme> = {
  width: '100%',
  height: '100%',
  position: 'absolute',
  zIndex: theme.zIndex.overlay,
  padding: theme.spacing(1),
};

export const overlayStyle = (showDropdownMenuDisabled: boolean): Interpolation<Theme> => ({
  width: '100%',
  height: '100%',
  backgroundColor: `${theme.colors.neutral90}33`,
  padding: theme.spacing(1),
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'space-between',
  ...(showDropdownMenuDisabled && {
    p: {
      fontStyle: 'italic',
      color: theme.colors.neutral20,
    },
  }),
});

export const overlayFooterContainerStyles: Interpolation<Theme> = {
  display: 'flex',
  width: '100%',
  padding: theme.spacing(0, 1),
  justifyContent: 'center',
  gap: theme.spacing(1),
  alignSelf: 'center',
};

export const chipWithLinkStyles: Interpolation<Theme> = {
  padding: theme.spacing(0.125, 0.5),
  backgroundColor: theme.colors.primary5,
  span: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(0.5),
    width: 'fit-content',
  },
  cursor: 'pointer',

  '&:hover': {
    boxShadow: theme.shadows.floating,
  },
};

export const iconStyles: Interpolation<Theme> = {
  borderRadius: theme.borderRadius.small,
  backgroundColor: theme.colors.white,
  padding: theme.spacing(0.5),
  height: 'auto',
  width: 'auto',
  minWidth: 'auto',
  border: 0,
  cursor: 'pointer',

  span: {
    svg: {
      color: theme.colors.neutral70,
    },
  },

  '&:hover:not([aria-disabled="true"]), &:active:not([aria-disabled="true"])': {
    background: theme.colors.neutral5,
  },

  '&:hover': {
    boxShadow: theme.shadows.floating,
  },
};

export const landingPageMenuStyles: Interpolation<Theme> = {
  background: theme.colors.white,
  borderColor: 'none',

  '&:hover': {
    boxShadow: theme.shadows.floating,
  },
};

export const reviewLinkStyles = (showBackground = false): Interpolation<Theme> => ({
  width: '100%',
  height: '360px',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  ...(showBackground && { backgroundColor: theme.colors.neutral40 }),
});
